export function sendLddLog(level: string, message: string, meta?: any) {
  if (process.env.NODE_ENV !== 'development') return;

  try {
    fetch('/api/dev/logger', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ level, message, meta }),
      // Keepalive ensures log is sent even if page is unloading
      keepalive: true,
    }).catch(console.error);
  } catch (error) {
    console.error('Failed to send LDD log:', error);
  }
}

export const clientLogger = {
  info: (message: string, meta?: any) => sendLddLog('info', message, meta),
  error: (message: string, meta?: any) => sendLddLog('error', message, meta),
  warn: (message: string, meta?: any) => sendLddLog('warn', message, meta),
  ldd_trace: (message: string, meta?: any) => sendLddLog('trace', message, meta),
};
